export default __webpack_public_path__ + "dc52ea2.png";